export const siteInfo = {
  name: '真人体育',
  tagline: '沉浸式真实赛事竞猜平台',
  description: '真人体育汇聚全球顶级赛事，提供足球、篮球、网球等真实赛事实时竞猜体验。真人体育平台安全可靠，赔率透明，支持实时数据分析，让您随时随地享受极致真人体育竞猜乐趣。',
  keywords: '真人体育,真人体育竞猜,真人体育赛事平台,真人体育实时赔率,真人体育在线投注,真人体育足球竞猜,真人体育篮球押注',
  url: 'https://zncighh.cn',
  logo: '真人体育',
  email: 'contact@zhenrentiyu.com',
  phone: '400-888-6666',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  foundingYear: '2018',
  socialLinks: {
    weibo: 'https://weibo.com/zhenrentiyu',
    wechat: 'zhenrentiyu666',
  },
};

export const categories = [
  {
    id: 'football',
    name: '足球竞猜',
    icon: 'ri-football-line',
    slug: 'football',
    description: '全球顶级足球赛事实时竞猜，涵盖英超、西甲、意甲、德甲、法甲等五大联赛及欧冠、世界杯等国际大赛。',
    matchCount: 128,
  },
  {
    id: 'basketball',
    name: '篮球押注',
    icon: 'ri-basketball-line',
    slug: 'basketball',
    description: 'NBA、CBA、欧洲篮球联赛等顶级篮球赛事实时竞猜，提供全场、半场、单节等多种玩法。',
    matchCount: 96,
  },
  {
    id: 'tennis',
    name: '网球竞猜',
    icon: 'ri-base-station-line',
    slug: 'tennis',
    description: 'ATP、WTA等全球网球巡回赛事实时竞猜，包括大满贯、大师赛等顶级赛事全覆盖。',
    matchCount: 64,
  },
];

export const matches = [
  {
    id: 'match-001',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeLogo: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-01&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=FC%20Barcelona%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-02&orientation=squarish',
    league: '西甲',
    category: 'football',
    startTime: '2026-08-13 03:00',
    status: 'upcoming',
    homeOdds: 2.45,
    drawOdds: 3.30,
    awayOdds: 2.85,
    popularity: 98,
    isHot: true,
    isLive: false,
  },
  {
    id: 'match-002',
    homeTeam: '曼彻斯特城',
    awayTeam: '利物浦',
    homeLogo: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-03&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Liverpool%20FC%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-04&orientation=squarish',
    league: '英超',
    category: 'football',
    startTime: '2026-08-13 00:30',
    status: 'live',
    homeOdds: 2.10,
    drawOdds: 3.50,
    awayOdds: 3.20,
    liveScore: '2:1',
    popularity: 95,
    isHot: true,
    isLive: true,
  },
  {
    id: 'match-003',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeLogo: 'https://readdy.ai/api/search-image?query=LA%20Lakers%20basketball%20team%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-05&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-06&orientation=squarish',
    league: 'NBA',
    category: 'basketball',
    startTime: '2026-08-13 10:00',
    status: 'upcoming',
    homeOdds: 1.85,
    awayOdds: 1.95,
    popularity: 92,
    isHot: true,
    isLive: false,
  },
  {
    id: 'match-004',
    homeTeam: 'AC米兰',
    awayTeam: '国际米兰',
    homeLogo: 'https://readdy.ai/api/search-image?query=AC%20Milan%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-07&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Inter%20Milan%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-08&orientation=squarish',
    league: '意甲',
    category: 'football',
    startTime: '2026-08-14 02:45',
    status: 'upcoming',
    homeOdds: 2.60,
    drawOdds: 3.10,
    awayOdds: 2.75,
    popularity: 88,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-005',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeLogo: 'https://readdy.ai/api/search-image?query=Novak%20Djokovic%20tennis%20player%20portrait%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-09&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Carlos%20Alcaraz%20tennis%20player%20portrait%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-10&orientation=squarish',
    league: 'ATP大师赛',
    category: 'tennis',
    startTime: '2026-08-14 20:00',
    status: 'upcoming',
    homeOdds: 1.90,
    awayOdds: 1.90,
    popularity: 86,
    isHot: true,
    isLive: false,
  },
  {
    id: 'match-006',
    homeTeam: '波士顿凯尔特人',
    awayTeam: '密尔沃基雄鹿',
    homeLogo: 'https://readdy.ai/api/search-image?query=Boston%20Celtics%20basketball%20team%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-11&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Milwaukee%20Bucks%20basketball%20team%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-12&orientation=squarish',
    league: 'NBA',
    category: 'basketball',
    startTime: '2026-08-15 08:30',
    status: 'upcoming',
    homeOdds: 1.72,
    awayOdds: 2.10,
    popularity: 82,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-007',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '多特蒙德',
    homeLogo: 'https://readdy.ai/api/search-image?query=Bayern%20Munich%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-13&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Borussia%20Dortmund%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-14&orientation=squarish',
    league: '德甲',
    category: 'football',
    startTime: '2026-08-16 00:30',
    status: 'upcoming',
    homeOdds: 1.55,
    drawOdds: 4.20,
    awayOdds: 5.50,
    popularity: 80,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-008',
    homeTeam: '斯瓦泰克',
    awayTeam: '萨巴伦卡',
    homeLogo: 'https://readdy.ai/api/search-image?query=Iga%20Swiatek%20tennis%20player%20portrait%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-15&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Aryna%20Sabalenka%20tennis%20player%20portrait%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-16&orientation=squarish',
    league: 'WTA巡回赛',
    category: 'tennis',
    startTime: '2026-08-16 16:00',
    status: 'upcoming',
    homeOdds: 1.65,
    awayOdds: 2.20,
    popularity: 75,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-009',
    homeTeam: '巴黎圣日耳曼',
    awayTeam: '马赛',
    homeLogo: 'https://readdy.ai/api/search-image?query=PSG%20Paris%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-17&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Marseille%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-18&orientation=squarish',
    league: '法甲',
    category: 'football',
    startTime: '2026-08-17 03:00',
    status: 'upcoming',
    homeOdds: 1.40,
    drawOdds: 4.80,
    awayOdds: 7.00,
    popularity: 72,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-010',
    homeTeam: '迈阿密热火',
    awayTeam: '费城76人',
    homeLogo: 'https://readdy.ai/api/search-image?query=Miami%20Heat%20basketball%20team%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-19&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Philadelphia%2076ers%20basketball%20team%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-20&orientation=squarish',
    league: 'NBA',
    category: 'basketball',
    startTime: '2026-08-17 09:00',
    status: 'upcoming',
    homeOdds: 2.05,
    awayOdds: 1.78,
    popularity: 70,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-011',
    homeTeam: '纳达尔',
    awayTeam: '梅德韦杰夫',
    homeLogo: 'https://readdy.ai/api/search-image?query=Rafael%20Nadal%20tennis%20player%20portrait%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-21&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Daniil%20Medvedev%20tennis%20player%20portrait%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-22&orientation=squarish',
    league: 'ATP巡回赛',
    category: 'tennis',
    startTime: '2026-08-18 18:00',
    status: 'upcoming',
    homeOdds: 2.30,
    awayOdds: 1.62,
    popularity: 68,
    isHot: false,
    isLive: false,
  },
  {
    id: 'match-012',
    homeTeam: '尤文图斯',
    awayTeam: '那不勒斯',
    homeLogo: 'https://readdy.ai/api/search-image?query=Juventus%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-23&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Napoli%20football%20club%20logo%20style%20icon%20on%20white%20background%2C%20minimalist%2C%20clean%20design&width=80&height=80&seq=match-team-24&orientation=squarish',
    league: '意甲',
    category: 'football',
    startTime: '2026-08-19 02:45',
    status: 'upcoming',
    homeOdds: 2.15,
    drawOdds: 3.20,
    awayOdds: 3.40,
    popularity: 65,
    isHot: false,
    isLive: false,
  },
];